<template>
    <v-dialog v-model="visible" width="700" @keydown.esc="visible = false">
        <v-toolbar dense color="primary">
            <v-toolbar-title>Part: {{ (item) ? item.part : null }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-text-field
                        v-validate="'integer|required|min_value:1'"
                        label="Quantity"
                        name="Quantity"
                        value="1"
                        type="number"
                        :error-messages="errors.collect('quantity')"
                        data-vv-name="quantity"
                        required
                        v-model="quantity"
                        min="1">
                </v-text-field>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
                <v-btn color="red" flat @click="visible = false">
                    Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="addToCart" title="Save & Close">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddQuoteDialog',
  props: {
  },
  data () {
    return {
      isNew: false,
      item: null,
      quantity: 1,
      visible: false
    }
  },
  methods: {
    ...mapActions(
      'quote', {
        add: 'add',
        update: 'update'
      }
    ),
    addToCart () {
      if (this.isNew) {
        this.add({
          vue: this,
          item: {
            part: this.item.part,
            quantity: this.quantity,
            price: this.item.price,
            symbol: this.item.symbol,
            currency: this.item.currency,
            stock: 0
          }
        })
      } else {
        this.update({
          vue: this,
          item: {
            id: this.item.id,
            shopping_cart_id: this.item.shopping_cart_id,
            part: this.item.part,
            quantity: this.quantity,
            price: this.item.price,
            symbol: this.item.symbol,
            currency: this.item.currency,
            stock: 0
          }
        })
      }
      this.visible = false
    },
    show ({ isNew, item, quantity }) {
      this.isNew = isNew
      this.item = item
      this.quantity = quantity
      this.visible = true
    },
    hide () {
      this.visible = false
      this.item = null
      this.quantity = 1
    }
  }
}
</script>

<style scoped>

</style>
